export type ParticipantRole = 'host' | 'co-host' | 'participant';

export function resolveRoleFromMetadata(metadata?: string | null): ParticipantRole {
  if (!metadata) {
    if (typeof window !== 'undefined') {
      try {
        if (window.sessionStorage.getItem('evolutto-force-host') === 'true') {
          return 'host';
        }
      } catch (error) {
        console.warn(
          'Não foi possível acessar sessionStorage para determinar o papel do participante:',
          error,
        );
      }
    }
    return 'participant';
  }

  try {
    const parsed = JSON.parse(metadata);

    if (parsed.forceHost === true || parsed.isHost === true) {
      return 'host';
    }

    if (parsed.role === 'host' || parsed.role === 'co-host') {
      return parsed.role;
    }
  } catch (error) {
    console.warn('Não foi possível interpretar a metadata do participante:', error);
    if (typeof window !== 'undefined') {
      try {
        if (window.sessionStorage.getItem('evolutto-force-host') === 'true') {
          return 'host';
        }
      } catch (sessionError) {
        console.warn(
          'Não foi possível acessar sessionStorage para determinar o papel do participante:',
          sessionError,
        );
      }
    }
  }

  return 'participant';
}

export function isHostRole(role: ParticipantRole): boolean {
  return role === 'host';
}

export function isCoHostRole(role: ParticipantRole): boolean {
  return role === 'co-host';
}

export function hasModeratorRole(role: ParticipantRole): boolean {
  return role === 'host' || role === 'co-host';
}
